<h1 class="page-title">Services</h1>

<div class="content-wrapper table-wrapper jobs-table-wrapper">
  <prism-jobs-table
          *ngIf="(jobs$ | async)?.length >= 1 || (jobsLoading$ | async)"
          [jobsCount]="(processor$|async)?.jobsCount || 0"
          (paginationEvent)="fetchJobs($event)"
          [jobs]="(jobs$ | async)">
  </prism-jobs-table>

  <div class="jobs-list-empty" *ngIf="(jobs$ | async)?.length <= 0  && !(jobsLoading$ | async)">
    <h5>No services have been added...</h5>
  </div>
</div>
